import React, { useState } from 'react';
import { TextField, Button, Paper, Snackbar, IconButton } from '@mui/material';
import { Share, ContentCopy, Check, Close } from '@mui/icons-material';
import styles from './ShareLinkComponent.module.scss';

const ShareLinkComponent = ({ shareLink }) => {
    const [copied, setCopied] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(shareLink);
            setCopied(true);
            setOpenSnackbar(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Share Link',
                    url: shareLink
                });
            } catch (err) {
                console.error('Error sharing: ', err);
            }
        } else {
            handleCopy();
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <div className={styles.shareLinkContainer}>
            <div className={styles.inputGroup}>
                <TextField
                    value={shareLink}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                        readOnly: true,
                        className: styles.textField
                    }}
                />
                <div className={styles.buttonGroup}>
                    <Button
                        variant="outlined"
                        onClick={handleCopy}
                        className={styles.copyButton}
                        startIcon={copied ? <Check /> : <ContentCopy />}
                    >
                        {copied ? 'Copied' : 'Copy'}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleShare}
                        className={styles.shareButton}
                        startIcon={<Share />}
                    >
                        Share
                    </Button>
                </div>
            </div>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                message="Link copied to clipboard!"
                action={
                    <IconButton
                        size="small"
                        color="inherit"
                        onClick={handleCloseSnackbar}
                    >
                        <Close />
                    </IconButton>
                }
            />
        </div>
    );
};

export default ShareLinkComponent;